import { Side } from '@protos/trading';

export interface OtcSymbolSpread {
  front: string;
  back: string;
}

export interface OtcSymbolButterfly {
  front: string;
  back: string;
  middle: string;
}

export interface OtcQuote {
  price: string;
  amount: string;
}

export type OtcQuoteSymbol = OtcSymbolSpread | OtcSymbolButterfly | string;

export interface OtcQuoteMessage {
  exchange: string;
  mid: string;
  timestamp: string;
  product_symbol: string;
  buy: OtcQuote;
  sell: OtcQuote;
  symbol: OtcQuoteSymbol;
}

export enum OtcExchange {
  ice = 'ice',
  cme = 'cme',
}

export enum OtcOrderType {
  unspecified = 'unspecified',
  fill_or_kill = 'fill_or_kill',
  limit = 'limit',
}

export const OtcOrderTypeDisplayTextMap: Map<OtcOrderType, string> = new Map<OtcOrderType, string>([
  [OtcOrderType.unspecified, 'Unspecified'],
  [OtcOrderType.fill_or_kill, 'Fill or Kill'],
  [OtcOrderType.limit, 'Limit'],
]);

export enum OtcOrderState {
  unspecified = 'unspecified',
  pending_created = 'pending_created',
  created = 'created',
  new = 'new',
  filled = 'filled',
  errored = 'errored',
}

export interface OtcQuoteOrder {
  account_id: string;
  symbol: OtcQuoteSymbol;
  amount: string;
  price: string;
  side: Side;
  order_type: OtcOrderType;
  exchange: OtcExchange;
}

export interface User {
  id: string;
  account_name: string;
  full_name: string;
  email: string;
}
export interface Fee {
  currency: string;
  rate: string;
  signed_amount: string;
}

export interface WebSocketBaseResponse {
  id: string;
  timestamp: string;
  method: string;
}

export interface OtcExecution {
  id: string;
  order_id: string;
  client_order_id: string;
  side: Side;
  account_id: string;
  exchange: OtcExchange;
  created_timestamp: string;
  symbol: string;
  price: string;
  amount: string;
  user: User;
  fee: Fee;
}

export interface OtcQuoteOrderResponse extends WebSocketBaseResponse {
  order_id: string;
  client_order_id: string;
  account_id: string;
  symbol: OtcQuoteSymbol;
  product_symbol: string;
  amount: string;
  side: Side;
  order_type: OtcOrderType;
  order_state: OtcOrderState;
  user: User;
  price: string;
  created_timestamp: string;
  exchange: OtcExchange;
  executed_avg_price: string;
  executed_amount: string;
  executions: OtcExecution[];
  message?: string;
  code?: string;
}

export interface OtcCancelOrderResponse extends WebSocketBaseResponse {
  request_id: string;
  error: string;
}
